import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { ReviewCard } from "./ReviewCard";
import Styles from "./style.module.scss";
import { RequestError } from "../../../../components/RequestError";

interface PublishedReview {
  _id: string;
  displayName: string;
  city?: string;
  sessionType?: string;
  reviewText: string;
  hasPhoto?: boolean;
}

export const TestimonialsOnMainPage: React.FC = () => {
  const [reviews, setReviews] = useState<PublishedReview[]>([]);
  const [status, setStatus] = useState<"loading" | "ready" | "error">("loading");

  const loadReviews = useCallback(() => {
    setStatus("loading");
    axios
      .get(`${process.env.REACT_APP_API_URL}/reviews/published?limit=2`, { timeout: 15000 })
      .then((response) => {
        setReviews(response.data);
        setStatus("ready");
      })
      .catch(() => {
        setReviews([]);
        setStatus("error");
      });
  }, []);

  useEffect(() => {
    loadReviews();
  }, [loadReviews]);

  if (status === "ready" && reviews.length === 0) return null;

  return (
    <section className={Styles.testimonials} aria-labelledby="home-testimonials-title">
      <div className={Styles.testimonials__inner}>
        <p className={Styles.testimonials__eyebrow}>Kind words from families</p>
        <h2 className={Styles.testimonials__title} id="home-testimonials-title">
          What families remember
        </h2>
        <p className={Styles.testimonials__intro}>
          A few honest words from families who trusted me with their memories.
        </p>
        {status === "loading" && <p className={Styles.testimonials__status}>Loading client reviews…</p>}
        {status === "error" ? (
          <RequestError message="Client reviews are temporarily unavailable." onRetry={loadReviews} />
        ) : (
          <div className={Styles.testimonials__grid}>
            {reviews.map((review) => (
              <ReviewCard
                key={review._id}
                displayName={review.displayName}
                city={review.city}
                sessionType={review.sessionType}
                reviewText={review.reviewText}
                photoSrc={review.hasPhoto ? `${process.env.REACT_APP_API_URL}/reviews/${review._id}/photo` : undefined}
                sourceLabel="Shared directly"
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
